import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { InputDefaultSettings } from 'src/app/shared/settings/input-default.setting';
import moment from 'moment';

/**
 * Окно запроса срока действия предложения
 */
@Component({
  selector: 'app-prolong-offer-dialog',
  templateUrl: './prolong-offer-dialog.component.html',
  styleUrls: ['./prolong-offer-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProlongOfferDialogComponent implements OnInit {
  /** Флаг отображения модального окна. */
  @Input() public visible: boolean;
  /** Ширина отображения модального окна. */
  @Input() public width: string;
  @Input() public styleClass: string;
  @Input() minY: number = 70;
  @Input() closable: boolean = true;
  /** Срок действия предложения */
  @Input() offerValidityDate: Date;

  /** Событие подтверждения */
  @Output() onConfirm = new EventEmitter<ProlongationOfferOutput>();

  /** Событие закрытия модального окна. */
  @Output() onHide = new EventEmitter<boolean>();

  /** Событие открытия модального окна. */
  @Output() onShow = new EventEmitter();

  /** Настройки для календаря */
  public inputSettings = InputDefaultSettings;

  /** Срок действия предложения */
  public validityDate: Date;

  /** Ограничения на срок действия */
  public validityDateContraints: DateContraint = { Minimum: null, Maximum: null };

  constructor() {
    this.validityDateContraints = {
      Minimum: moment().add(1, 'd').toDate(),
      Maximum: moment().add(1, 'M').toDate(),
    };
  }

  ngOnInit() {
    this.validityDateContraints.Minimum = moment().add(1, 'd').toDate();
    this.validityDateContraints.Maximum = moment().add(1, 'M').toDate();
  }

  public onProlongDialogOkButtonClick(event: any) {
    this.visible = false;
    this.onConfirm.emit({
      Event: event,
      ValidityDate: this.validityDate,
    });
  }

  /**
   * Обработчик закрытия окна.
   * @param event событие.
   */
  public onClose(event: any) {
    this.onHide.emit(event);
  }

  /**
   * Обработчик открытия окна.
   * @param event событие.
   */
  public onOpen(event) {
    this.onShow.emit(event);
  }
}

/** Ограничения на срок действия предложения */
class DateContraint {
  public Maximum: Date;
  public Minimum: Date;
}

/** Представляет результат выбора срока действия предложения */
export class ProlongationOfferOutput {
  public Event: any;
  public ValidityDate: Date;
}
